"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchHeadline;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
var _siteSearchContext = require("./site-search-context");
var _text = _interopRequireDefault(require("@ux/text"));
var _core = require("@linaria/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SearchHeadlineContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SearchHeadlineContainer",
  class: "pl-s1nc2alc"
});
const textContainer = "pl-ty1xqn5";
const MainElement = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "MainElement",
  class: "pl-m1h61sdb"
});
/**
  * Render Search Headline Component.
  *
  * @param {object} props React props for element
  * @param {string} props.headlineTemplate Headline template
  * @returns {React.ReactElement} SearchHeadline component
  * @public
  */
function SearchHeadline({
  headlineTemplate: initialHeadlineTemplate
}) {
  const {
    searchValue
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const [headlineTemplate, setHeadlineTemplate] = (0, _react.useState)(initialHeadlineTemplate);
  (0, _react.useEffect)(() => {
    if (initialHeadlineTemplate.includes('"')) {
      const newHeadlineTemplate = initialHeadlineTemplate.replace(new RegExp('"', 'g'), ' ');
      setHeadlineTemplate(newHeadlineTemplate);
    }
  }, [initialHeadlineTemplate]);
  const formatsSearchValue = str => {
    const beforeInd = str.indexOf('{');
    const afterInd = str.indexOf('}');
    return /*#__PURE__*/_react.default.createElement(_text.default.div, {
      className: textContainer,
      as: "title",
      size: 1
    }, headlineTemplate.substring(0, beforeInd), /*#__PURE__*/_react.default.createElement(MainElement, {
      "data-cy": "search-value"
    }, `"${searchValue}"`), headlineTemplate.substring(afterInd + 2));
  };
  return /*#__PURE__*/_react.default.createElement(SearchHeadlineContainer, {
    "data-cy": "search-headline"
  }, formatsSearchValue(headlineTemplate));
}
SearchHeadline.propTypes = {
  headlineTemplate: _propTypes.default.string
};